import { InjectionToken } from '@angular/core';

/**
 * Whether the Design section runs with the Domains & Projects navigator (EFF-26168): the menu in the
 * shell's side panel, `/projects` as a landing that resumes the last project, and the project's name in
 * the header instead of the subheader.
 *
 * **A property of the build, not of the user.** Only the build WITH the Control Center has a side panel
 * to host the menu, so only `platform.routes.ts` provides `true`, on the Design branch of its route
 * table. The build without it inherits the `false` default and keeps the Projects list page, the header
 * navigation and the subheader title it always had.
 *
 * Read by route guards (`canMatch`) and by components under the Design branch. The navigator's own code
 * is reached only through `import()` behind this flag, so the build that leaves it `false` ships none of
 * it. It reports which layout is on, never what the user may do — no permission decision reads it.
 */
export const PROJECT_NAVIGATOR_ENABLED_TOKEN = new InjectionToken<boolean>('PROJECT_NAVIGATOR_ENABLED_TOKEN', {
	factory: () => false,
});
